import { lazy, Suspense } from "react"
const LazyTrappaImg = lazy(() => import ("../Visuals/TrappaImg"))

const AltLanding = () => {
    return (
        <div className="py-24">
            <div className=" grid grid-cols-1 lg:grid-cols-2 gap-x-4 gap-y-16 max-w-6xl mx-auto ">
                <div className="flex flex-col justify-center gap-4 max-w-lg mx-auto px-4">
                    <h1 className="text-3xl font-bold fg-color-1">
                        Ansök till värd
                    </h1>

                    <p className="text-lg fg-color-2  leading-8 max-w-[45ch]">
                        Att vara värd ger dig en chans att få nära kontakt med
                        en arbetsgivare du själv väljer
                    </p>
                    <div className="flex w-full lg:w-auto pt-2">
                        <a
                            href="https://hotspot.kau.se/vardrekrytering-registrera-dig/"
                            target="_blank"
                            className=" p-4 px-12 bg-gradient-to-br from-neutral-700 to-neutral-800 dark:from-neutral-100 dark:to-neutral-200 inset-0 text-white dark:text-black font-semibold text-center rounded-lg dark:hover:from-white dark:hover:to-white hover:from-black hover:to-black"
                        >
                            Till Ansökan
                        </a>
                    </div>
                </div>
                <Suspense fallback={<div className="w-full h-80"></div>}>
                    <LazyTrappaImg />
                </Suspense>
            </div>
        </div>
    )
}

export default AltLanding
